module.exports = __webpack_public_path__ + "static/media/7.d66ceb41.jpg";